export default {"src":"/_next/static/media/padlock-locked.8fb685b0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};